/*
生産性が高いこと ＝　明確であること ＝　明示的であること、重複がないこと　＝　８割の共通事項と２割の例外事項に対応できること

react と node.js の両方で共有される module
import なしで使用できる module のみが対象

promise の戻り値は await により取得可能

デバッグの確認ポイント
データ作成処理が実行されているか（処理を通っているか）
作成されたデータが想定どおりか
データ表示処理が実行されているか（処理を通っているか）
表示されたデータが想定どおりか

function の上書きは行わない、処理が多重化される危険性が高まる

よくあるエラー・ワーニング
Require cycles are allowed, but can result in uninitialized values. Consider refactoring to remove the need for a cycle.
import が循環しているため、不要な import を削除する

android で hermes を使用

android/app/build.gradle
project.ext.react = [
    enableHermes: true,

cd android && ./gradlew clean

map で filter の余地がないか


 */

//import moment from "moment"

String.prototype.f = function () { // format
  let _i = 0, _args = arguments;
  return this.replace(/{}/g, function () {
    return (typeof _args[_i] != undefined) ? ((ff.myCM_chkType(_args[_i], 'dny') || ff.myCM_chkType(_args[_i], 'list')) ? ff.s(_args[_i++], true) : _args[_i++]) : '';
  });
};

export default class ff {

  ////////////////////////////////////////////////////////////////////////
/*
  static b(pld_whenThen) { // branch
    for (let [_idx, _d_whenThen] of ff.e(pld_whenThen)) {
      if (_d_whenThen.b_when) {
        return _d_whenThen.o_then();
      }
      else if (_d_whenThen.o_else) {
        return _d_whenThen.o_else();
      }
    };
  };
*/

  static c(pa_vals1, pa_vals2) { // concatenate list or dictionary
    if (ff.myCM_chkType(pa_vals1, 'list')) {
      return pa_vals1.concat(pa_vals2);
    };
    if (ff.myCM_chkType(pa_vals1, 'dny')) {
      return { ...pa_vals1, ...pa_vals2};
    };
  };

  static e(pa_vals) { // entries
    //
    if (!ff.f(pa_vals)) {
      return [];
    };
    //
    if (ff.myCM_chkType(pa_vals, 'dny')) {
      return Object.keys(pa_vals).entries()
    };
    if (ff.myCM_chkType(pa_vals, 'list')) {
      return pa_vals.entries()
    };
  };

  static f(pa_val){ // check not blank (fulfilled)
    //
    if (pa_val == null) {
      return false;
    }
    else if (pa_val == undefined) {
      return false;
    }
    else {
      if (ff.myCM_chkType(pa_val, 'dny')) {
        if (Object.keys(pa_val).length == 0) {
          return false;
        }
        else {
          return true;
        };
      }
      else if (ff.myCM_chkType(pa_val, 'list')) {
        if (pa_val.length == 0) {
          return false;
        }
        else {
          return true;
        };
      }
      else {
        if (pa_val == NaN) {
          return false;
        }
        else if (pa_val == '') {
          return false;
        }
        else if (pa_val == 'None') {
          return false;
        }
        else if (pa_val == 'null') {
          return false;
        }
        return true;
      };
    };
  };

  static i(pa_vals, pl_vals){ // check in
    if (ff.myCM_chkType(pa_vals, 'dct')) {
      let _r = pl_vals;
      for (let [_key, _val] of bf.e(pa_vals)) {
        if (_r) {
          _r = _r.filter( _d_is => {
            return (_d_is[_key] == _val)
          });
        }
        else {
          break;
        }
      }
      if (bf.f(_r)) {
        return true;
      }
      else {
        return false;
      };
    }
    else {
//ff.l('ff 146: {}, {}'.f(pa_vals, pl_vals))
      if (pl_vals?.indexOf(pa_vals)>=0) {
        return true;
      }
      else {
        return false;
      };
    };
  };

  static j(p_str){ // from string to json
    if (ff.f(p_str)){
      return JSON.parse(p_str);
    }
    else {
      return null;
    };
  };

  static l(p_str) {
    console.log('[{}] {}'.f(ff.myDT_getNow().substr(14, 5), p_str));
  };

/*
  static n(p_val) { // from string to number
    return (ff.f(p_val)) ? Number(String(ff.myCM_cnv('han', p_val)).replace(/,/g, '')) : 0;
  };
*/
  static n(p_val) { // from string to number
    let _n = Number(String(ff.myCM_cnv('han', p_val)).replace(/,/g, ''));
    if (_n) return _n;
    return null;
  };

  static q(p_qry) { // query
    return p_qry.replace(/"/g, "'").replace(/\[/g, '"').replace(/\]/g, '"').replace(/;/g, '').replace(/IFNULL/g, 'COALESCE');
  };

  static s(pd_vals, pb_fmt=false){ // from json to string
    if (pb_fmt) {
      return JSON.stringify(pd_vals, null, 2);
    }
    else {
      return JSON.stringify(pd_vals);
    };
  };

  ////////////////////////////////////////////////////////////////////////
  static myCR_send_json = (pd={
    method: 'POST/GET',
    url: '',
    type: '',
    d_vals: {},
  }) => new Promise( _o_end1 => {
    let _d_opts = {
      method: pd.method || 'POST',
      body: ff.s({
        type: pd.type || '',
        d_vals: pd.d_vals || {},
      }),
      mode: 'cors',
      headers: {
        'Accept': 'application/json',
        "Content-Type": 'application/json',
      },
    };
    //ff.l('ff 212: {}'.f(_d_opts));
    fetch(pd.url, _d_opts)
    .then( _res => {
//ff.l('213');
      _o_end1(_res.json());
    })
    .catch( _err => {
      _o_end1(null);
    });
  });

//////////////////////////////////////////////////////////////////////// common module
static myCM_chkType(pa_val, p_type){
  //
  if (p_type == 'dny') {
    if (ff.myCM_getType(pa_val) == 'object'){
      return true;
    };
  }
  else if (p_type == 'list') {
    if (ff.myCM_getType(pa_val) == 'array'){
      return true;
    };
  }
  else if (p_type == 'nmb') {
    if (ff.myCM_getType(ff.n(pa_val)) == 'number'){
      return true;
    };
  }
  else if (p_type == 'str') {
    if (ff.myCM_getType(pa_val) == 'string'){
      return true;
    };
  }
  else if (p_type == 'fcn') { // function
    if (ff.myCM_getType(pa_val) == 'function'){
      return true;
    };
  };
  //
  return false;
};

static myCM_clw = (pn_sec, po_fnc) => new Promise( _o_end1 => { // clock work
    let _id = setInterval(()=>{
      if (po_fnc && po_fnc()) {
        clearInterval(_id);
        _o_end1();
      };
    }, pn_sec * 1000)
});

  static myCM_cnv(p_mode, pa_val){ // async の場合に Base64 が正しく動作しない場合がある模様
    if (p_mode == 'str') { // from json to string
      return String(pa_val); // 数値の場合
    };

    if (p_mode == 'bytes') { // from string to json
      return Array.from(pa_val).reduce( (_prev, _s) => {
        let _c = String(_s).charCodeAt(0)
        if ((_c >= 0x0 && _c < 0x81) || (_c === 0xf8f0) || (_c >= 0xff61 && _c < 0xffa0) || (_c >= 0xf8f1 && _c < 0xf8f4)) return _prev + 1;
        return _prev + 2;
      }, 0);
    };

    if (p_mode == 'ceil') { // 切り捨て
      return Math.ceil(pa_val);
    };
    //
    if (p_mode == 'cmm' || p_mode == 'comma') { // カンマ区切り
      let _l = String(pa_val).replace(/,/g, '').split('.');
      let _r = String(_l[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
      if (_l.length > 1) {
          _r += '.' + _l[1];
      }
      return _r;
    };

    if (p_mode == 'flr' || p_mode == 'floor') { // 切り捨て
      return Math.floor(pa_val);
    };

    if (p_mode == 'han') { // 半角
      return String(pa_val).replace( /[Ａ-Ｚａ-ｚ０-９]/g, (_s) => String.fromCharCode(_s.charCodeAt(0) - 65248));
    };

    if (p_mode == 'json') { // from string to json
      return JSON.parse(pa_val);
    };

    if (p_mode == 'list') { // from dictionary to list 
      return Object.entries(pa_val)
    };

    if (p_mode == 'list-csv') { 
      return pa_val.list.reduce( (_prev, _date) => _prev + (ff.f(_prev) ? ',' : '') + `${pa_val.dlm ?? ``}${_date}${pa_val.dlm ?? ``}`, '');
    };

    if (p_mode == 'nmb') { // from string to number 
      return parseFloat(pa_val)
    };

    if (p_mode == 'lwr') { // lower 
      return String(pa_val).toLowerCase();
    };

    if (p_mode == 'msr-dtm') { // measure to dtm
      return ff.myDT_addMnt(pa_val.sttDate, ff.myCM_cnv('flr', pa_val.n_x / pa_val.n_d * pa_val.n_u))
    };

    if (p_mode == 'dtm-msr') { // measure to dtm 
      let _n_dff = ff.myDT_getDff('mnt', pa_val.sttDate, pa_val.endDate);
      return ff.myCM_cnv('flr', _n_dff / pa_val.n_u * pa_val.n_d)
    };

    if (p_mode == 'px-msr') { // pixel to measure
      return ff.n(pa_val.substr(0, pa_val.length-2))
    };

    if (p_mode == 'str-ary') { // decode uri
      return ff.myCM_get_rng(pa_val.length).map( _i => {
        return pa_val.charCodeAt(_i - 1)
      })
    };

    if (p_mode == 'trim') { // trim 
      return String(pa_val).trim();
    };

    if (p_mode == 'upr') { // upper 
      return String(pa_val).toUpperCase();
    };

    if (p_mode == 'ecd-6dgt') { // encode 6 digit, 980000 まで対応

      let _n0 = 8721; // same with end and dcd, 9999 まで
      let _d1 = { // same with ecd and dcd
        '0': '2', 
        '1': '5', 
        '2': '7',
        '3': '4',
        '4': '3',
        '5': '9',
        '6': '8',
        '7': '6',
        '8': '1',
        '9': '0',
      };

      let _n1 = ff.n(pa_val.n_nbr);
      _n1 += _n0;
      let _s1 = ff.myCM_pdd(_n1, 6, '0')
      let _l1 = Array.from(_s1);

      let _s2 = '';
      _s2 += _d1[_l1[0]];
      _s2 += _d1[_l1[1]];
      _s2 += _d1[_l1[2]];
      _s2 += _d1[_l1[3]];
      _s2 += _d1[_l1[4]];
      _s2 += _d1[_l1[5]];

      return _s2;
    };

    if (p_mode == 'dcd-6dgt') { // encode 6 digit

      let _n0 = 8721; // same with end and dcd, 9999 まで
      let _d1 = { // common with _dcd
        '0': '2', 
        '1': '5', 
        '2': '7',
        '3': '4',
        '4': '3',
        '5': '9',
        '6': '8',
        '7': '6',
        '8': '1',
        '9': '0',
      };

      let _d2 = {}
      Object.keys(_d1).map( _key => {
        _d2[_d1[_key]] = _key;
      });
      let _l2 = Array.from(String(pa_val.n_nbr));

      let _s3 = '';
      _s3 += _d2[_l2[0]];
      _s3 += _d2[_l2[1]];
      _s3 += _d2[_l2[2]];
      _s3 += _d2[_l2[3]];
      _s3 += _d2[_l2[4]];
      _s3 += _d2[_l2[5]];

      return ff.n(_s3) - _n0;
    };

    if (p_mode == 'pwd') { // password 6 digit
      let _pwd = String(`${ff.myCM_getRnd(9)}${pa_val.n_nbr * 2 + 1324 }${pa_val.n_nbr + 3}A@2b!=`).substr(0, 8);
      return _pwd;
    };

    if (p_mode == 'chkPwd') { // password 6 digit
      let _pwd = String(`${pa_val.n_nbr * 2 + 1324 }${pa_val.n_nbr + 3}A@2b!=`).substr(0, 7);
//ff.l('ff 399: {}, {}'.f(pa_val.pwd.substr(1), _pwd))
      if (pa_val.pwd.substr(1) == _pwd) return true;
      return false;
    };


    alert('287: incorrect mode: {}'.f(p_mode))

  };

  static myCM_copy(pa_val) { // ディープコピー
    if (ff.myCM_chkType(pa_val, 'dny')) {
//ff.l('289: here')
      return Object.assign({}, pa_val);
    };
    if (ff.myCM_chkType(pa_val, 'list')) {
//ff.l('292: here')
      return pa_val.concat();
    };
  };

  static myCM_getDny = (pd={ // get dictionary ld_iss において fld == val である d_items を取得
    mode: 'is/idx', // is: items
    ld_iss: [{}],
    fld: '',
    val: '',
  }) => {
//ff.l('443: {}'.f(pd.ld_iss))
    let _r = Array.from(pd.ld_iss ?? []).filter( _d_is => (_d_is[pd.fld] == pd.val) ? true : false)
    .reduce( (_prev, _d_is) => {
      return _d_is
    }, {});
//ff.l('160:{}'.f(_r));
    return _r;
  };

static myCM_getLen(pa_val){
  if (ff.myCM_chkType(pa_val, 'dny')) {
    return Object.keys(pa_val).length;
  };
  if (ff.myCM_chkType(pa_val, 'list')) {
    return pa_val.length;
  };
  if (ff.myCM_chkType(pa_val, 'str')) {
    return pa_val.length;
  };
};

//static myCM_get_rnd(pn_max=1){
static myCM_getRnd(pn_max=1){
  return Math.floor( Math.random() * (ff.n(pn_max) + 1));
};

static myCM_swap(pl, pn1, pn2){
  [pl[pn1], pl[pn2]] = [pl[pn2], pl[pn1]];
};

static myCM_getRng(pn_to, pn_from=1, pb_sfl=false){ // pb_sfl: shuffle
  if (pb_sfl == false) {
    return ((pn_to-pn_from+1) >= 1) ? Array.from(new Array(pn_to-pn_from+1)).map((p_v, p_i) => p_i + pn_from) : [];
  };
  if (pb_sfl == true) {
    let _l = ff.myCM_getRng(pn_to);
    ff.myCM_getRng(pn_to).map( _i => {
      let _j = ff.myCM_getRnd(pn_to - 1)
      ff.myCM_swap(_l, _i-1, _j);
    });
    return _l;
  };
};

static myCM_getType(pa_val) {
  return Object.prototype.toString.call(pa_val).slice(8, -1).toLowerCase();
};

static myCM_gnr(pn_len, p_str="abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"){ // 専用にカスタマイズ
  let _s = p_str;        
  let _r = ff.myDT_getNow().replace(/-/g,'').replace(/ /g,'').replace(/:/g,'');
  for(var _i=0; _i<pn_len; _i++){
//    _r += _s[this.myCM_get_rnd(_s.length-1)];
    _r += _s[this.myCM_getRnd(_s.length-1)];
  }
  return _r
};

static myCM_pdd(p_val, pn_len, p_chr='0'){ // padding
  return (p_chr.repeat(pn_len) + p_val).slice(-pn_len);
};

/*
static myCM_srl = (plop_pms) =>  new Promise( async _o_end1 => { // serials
  let _op_pms = plop_pms.shift();
  if (_op_pms) {
    _op_pms()
    .then( async _b_res => {
      if (_b_res != false) {
        if (ff.f(plop_pms)) await ff.myCM_srl(plop_pms);
        _o_end1();
      }
      else {
        _o_end1();
      }
    });
  }
  else {
    _o_end1();
  }
});
*/
static myCM_srl = (plop_pms) =>  new Promise( async _o_end1 => { // serials
  let _op_pms = plop_pms.shift();
  if (_op_pms) {
    _op_pms()
    .then( async _b_res1 => {
      if (_b_res1 != false) {
        let _b_res2 = true;
        if (ff.f(plop_pms)) _b_res2 = await ff.myCM_srl(plop_pms);
//ff.l('377: {}, {}'.f(_b_res1, _b_res2));
        _o_end1(_b_res1 && _b_res2);
      }
      else {
//ff.l('381: here');
        _o_end1(false);
      }
    });
  }
  else {
//ff.l('387: here');
    _o_end1(true);
  }
});

static myCM_substr(p_srg, pn_byte) { // byte 指定の substr
    let _r = '';
    Array.from(pa_val).reduce( (_prev, _s) => {
      let _c = String(_s).charCodeAt(0)
      if ((_c >= 0x0 && _c < 0x81) || (_c === 0xf8f0) || (_c >= 0xff61 && _c < 0xffa0) || (_c >= 0xf8f1 && _c < 0xf8f4)) _prev += 1;
      _prev += 2;
      _r += (_prev <= pn_byte) ? _s : '';
    }, 0);
    return _r;
};

static myCM_wait = (pn_sec) => new Promise( _o_end1 => {
  setTimeout(_o_end1, pn_sec * 1000)
});


  //////////////////////////////////////////////////////////////////////// date time
// moment を使用しない実装を検討要
//static myDT_add(p_mode, p_dtm, pn_val) {
//  if (p_mode == 'mnt') {
//    return moment(p_dtm, 'YYYY-MM-DD HH:mm:ss').add(pn_val, 'minutes').format('YYYY-MM-DD HH:mm:ss');
//  }
//};

//static myDT_add_date(p_dtm, pn_day) {
/*
static myDT_addDay(p_dtm, pn_day) {
  let _dtm = new Date(p_dtm);
  _dtm.setDate(_dtm.getDate() + pn_day);
  return ff.myDT_cnv('date-fmt', _dtm);
};

static myDT_addMth(p_dtm, pn_mth) {
  let _dtm = new Date(p_dtm);
  _dtm.setMonth(_dtm.getMonth() + pn_mth);
  return ff.myDT_cnv('date-fmt', _dtm);
};
*/
static myDT_add(p_mode, p_dtm, pn_val) {
  if (p_mode == 'day') {
    let _dtm = new Date(p_dtm);
    _dtm.setDate(_dtm.getDate() + pn_val);
    return ff.myDT_cnv('date-fmt', _dtm);
  };
  if (p_mode == 'mth') {
    let _dtm = new Date(p_dtm);
    _dtm.setMonth(_dtm.getMonth() + pn_val);
    return ff.myDT_cnv('date-fmt', _dtm);
  };
  if (p_mode == 'year') {
    let _dtm = new Date(p_dtm);
    _dtm.setYear(_dtm.getYear() + pn_val);
    return ff.myDT_cnv('date-fmt', _dtm);
  };
};

static myDT_cnv(p_mode, pa_dtm){
  if (p_mode == 'date-fmt') {
    let _dtm = pa_dtm;
    let _opt = {
      year: "numeric", 
      month: "2-digit", 
      day: "2-digit", 
    };
    return _dtm.toLocaleDateString("ja-JP", _opt).replace(/\//g, '-');
  };
  if (p_mode == 'dtm-fmt') {
    let _dtm = pa_dtm;
    let _opt = {
      year: "numeric", 
      month: "2-digit", 
      day: "2-digit", 
      hour: "2-digit", 
      minute: "2-digit", 
      second: "2-digit"
    };
    return _dtm.toLocaleDateString("ja-JP", _opt).replace(/\//g, '-');
  };
  if (p_mode == 'JST-UTC'){
    let _dtm = new Date(pa_dtm);
    return _dtm.toUTCString();
  };
  if (p_mode == '24') { // 24時以上を24時未満に変更
    let _dtm = pa_dtm;
    let _hh = ff.n(_dtm.substr(11,2));
    if (_hh >= 24) {
      _dtm = '{} 23:{}'.f(_dtm.substr(0,10), _dtm.substr(14,5));
      _dtm = ff.myDT_add_mnt(_dtm, (_hh - 23) * 60);
    };
    return _dtm;
  }
  if (p_mode == 'scd-ms') { // 秒 を 分秒に変換
    let _m = pa_dtm / 60 | 0;
    let _s = pa_dtm % 60;
    return '{}:{}'.f(ff.myCM_pdd(_m, 2), ff.myCM_pdd(_s, 2));
  };
  if (p_mode == 'scd-hms') { // 秒 を 時分秒に変換
    let _h = pa_dtm / 3600 | 0;
    let _m = pa_dtm % 3600 / 60 | 0;
    let _s = pa_dtm % 60;
    return '{}:{}:{}'.f(ff.myCM_pdd(_h, 2), ff.myCM_pdd(_m, 2), ff.myCM_pdd(_s, 2));
  };
//  if (p_mode == 'lastDate') { // last date of the month 月末に変換
  if (p_mode == 'ldm') { // last date of the month 月末に変換
    let _dtm = new Date(pa_dtm);
    _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth() + 1, 0); // 今月末
    return ff.myDT_cnv('date-fmt', _dtm);
  };
  if (p_mode == 'ldw') { // last date of the week 週末に変換
    let _dtm = new Date(pa_dtm);
//    _dtm = ff.myDT_add('day', _dtm, 6 - ff.myDT_cnv('now', _dtm));
//    return ff.myDT_cnv('date-fmt', _dtm);
    return ff.myDT_add('day', _dtm, 6 - ff.myDT_cnv('now', _dtm));
  };
//  if (p_mode == 'fstDate') { // 月初に変換
  if (p_mode == 'fdm') { // first date of the month 月初に変換
    let _dtm = new Date(pa_dtm);
    _dtm = new Date(_dtm.getFullYear(), _dtm.getMonth(), 1); // 今月末
    return ff.myDT_cnv('date-fmt', _dtm);
  };
  if (p_mode == 'fdw') { // first date of the week 週初に変換
    let _dtm = new Date(pa_dtm);
//    _dtm = ff.myDT_add('day', _dtm, - ff.myDT_cnv('now', _dtm));
//    return ff.myDT_cnv('date-fmt', _dtm);
    return ff.myDT_add('day', _dtm, - ff.myDT_cnv('now', _dtm));
  };
  if (p_mode == 'mth') { // 月に変換
    return ff.n(String(pa_dtm).substr(5, 2));
  };
  if (p_mode == 'year') { // 年月に変換
    return String(pa_dtm).substr(0, 4);
  };
  if (p_mode == 'year-mth') { // 年月に変換
    return String(pa_dtm).substr(0, 7);
  };
  if (p_mode == 'day') { // 日付に変換
    return ff.n(String(pa_dtm).substr(8, 2));
  };
  if (p_mode == 'dow') { // day of the week 曜日に変換
    let _dtm = new Date(pa_dtm);
    return [ "日", "月", "火", "水", "木", "金", "土" ][_dtm.getDay()]; 
  };
  if (p_mode == 'now') { // number of the week 曜日番号に変換
    let _dtm = new Date(pa_dtm);
    return _dtm.getDay(); 
  };
  if (p_mode == 'dates') { // 日付の一覧
      let _sttDate = pa_dtm.stt;
      let _endDate = pa_dtm.end;
      let _n_days = ff.myDT_getDff('day', _sttDate, _endDate);
      return ff.myCM_getRng(_n_days + 1).map( _cnt => ff.myDT_add('day', _sttDate, _cnt - 1));
  };
  if (p_mode == 'mthDates') { // 指定日を含む月の日付の一覧
    let _dtm = new Date(pa_dtm);
//    let _fstDate = ff.myDT_cnv('fstDate', _dtm);
    let _fstDate = ff.myDT_cnv('fdm', _dtm);
//    let _n_lastDay = ff.myDT_cnv('day', ff.myDT_cnv('lastDate', _dtm));
    let _n_lastDay = ff.myDT_cnv('day', ff.myDT_cnv('ldm', _dtm));
//    return ff.myCM_getRng(_n_lastDay).map( _n_day => ff.myDT_addDay(_fstDate, _n_day - 1));
    return ff.myCM_getRng(_n_lastDay).map( _n_day => ff.myDT_add('day', _fstDate, _n_day - 1));
  };
  if (p_mode == 'cdrMthDates') { // 指定日を含むカレンダー月の日付の一覧
    let _dtm = new Date(pa_dtm);
    let _fstDate = ff.myDT_cnv('fdm', _dtm);
    let _lastDate = ff.myDT_cnv('ldm', _dtm);
    let _n_lastDay = ff.myDT_cnv('day', _lastDate);
    return ff.myCM_getRng(_n_lastDay + ( 6 - ff.myDT_cnv('now', _lastDate)), 1 - ff.myDT_cnv('now', _fstDate)).map( _n_day => ff.myDT_add('day', _fstDate, _n_day - 1));
  };
  if (p_mode == 'cdrWeekDates') { // 指定日を含むカレンダー月の日付の一覧
    let _dtm = new Date(pa_dtm);
//    let _sttDate = ff.myDT_add('day', _dtm, - ff.myDT_cnv('now', _dtm));
    let _sttDate = ff.myDT_cnv('fdw', _dtm);
//    let _endDate = ff.myDT_add('day', _sttDate, 7 - 1);
    let _endDate = ff.myDT_cnv('ldw', _dtm);
    let _n_days = ff.myDT_getDff('day', _sttDate, _endDate);
    return ff.myCM_getRng(_n_days + 1).map( _cnt => ff.myDT_add('day', _sttDate, _cnt - 1));
  };
  if (p_mode == 'thisDates') { // 指定日から始まる一ヶ月の日付の一覧
      let _sttDate = pa_dtm;
      let _endDate = ff.myDT_add('day', ff.myDT_add('mth', _sttDate, 1), -1);
      let _n_days = ff.myDT_getDff('day', _sttDate, _endDate);
      return ff.myCM_getRng(_n_days + 1).map( _cnt => ff.myDT_add('day', _sttDate, _cnt - 1));
  };
  if (p_mode == '西暦月日'){
    let _dtm = new Date(pa_dtm);
    let _opt = {
      year: "numeric", 
      month: "long", 
//      day: "2-digit", 
      day: "numeric", 
      weekday: "short", 
    };
    return _dtm.toLocaleDateString("ja-JP", _opt);
  };
  if (p_mode == '西暦月'){
    let _dtm = new Date(pa_dtm);
    let _opt = {
      year: "numeric", 
      month: "long", 
    };
    return _dtm.toLocaleDateString("ja-JP", _opt);
  };
  if (p_mode == '和暦月日'){
    let _dtm = new Date(pa_dtm);
    let _opt = {
      year: "numeric", 
      month: "long", 
//      day: "2-digit", 
      day: "numeric", 
      weekday: "short", 
    };
    return _dtm.toLocaleDateString("ja-JP-u-ca-japanese", _opt);
  };

  if (p_mode == 'nth-dow'){ // date が属する月の、第 n_frc 回目の n_dow 曜日

    let _fdm = ff.myDT_cnv('fdm', pa_dtm.date);
    let _dtm = new Date(_fdm);
    let _n_fstDow = _dtm.getDay(); 

    let _n_dff = 0;
    if ( pa_dtm.n_dow >= _n_fstDow) {
      _n_dff = pa_dtm.n_dow - _n_fstDow;
    };
    if ( pa_dtm.n_dow < _n_fstDow) {
      _n_dff = 7 - (_n_fstDow - pa_dtm.n_dow);
    };
    let _fstDowDate = ff.myDT_add('day', _fdm, _n_dff);
    let _tgtDowDate = ff.myDT_add('day', _fstDowDate, 7 * ( pa_dtm.n_frc - 1))
    return _tgtDowDate;
  };

  if (p_mode == 'nth-dow-dates'){ // sttDate から endDate までの 第 n_frc 回目の n_dow 曜日の一覧
    let _sttDate = pa_dtm.sttDate;
    let _endDate = pa_dtm.endDate;
    let _n_frc = pa_dtm.n_frc;
    let _n_dow = pa_dtm.n_dow;

    let _l_dates = [];
    if ( ff.f(_sttDate) && ff.f(_endDate) && _n_frc > 0 && _n_dow >= 0) {
      let _date = ff.myDT_cnv('fdm', _sttDate);
      while ( _date <= _endDate ) {
        let _dowDate = ff.myDT_cnv('nth-dow', {date: _date, n_frc: _n_frc, n_dow: _n_dow});
        if ( _dowDate >= _sttDate && _dowDate <= _endDate ) {
          _l_dates.push(_dowDate);
        }
        _date = ff.myDT_add('mth', _date, 1);
      };    
    };
    return _l_dates;
  };

};

static myDT_getDate(p_date='today', pn_mth=0, pn_day=0, p_mode='-') {

  let _date2 = new Date();

  if (p_date != 'today') {
    _date2 = new Date(p_date);
  }

  if (pn_mth != 0) {
    _date2 = new Date(_date2.getFullYear(), _date2.getMonth() + pn_mth, _date2.getDay());
  };

  if (pn_day != 0) {
    _date2 = new Date(_date2.getFullYear(), _date2.getMonth(), pn_day);
  };

  let _YYYY = _date2.getFullYear();

  let _MM = _date2.getMonth() + 1;
  if (_MM < 10) {_MM = '0' + _MM};

  let _DD = _date2.getDate();
  if (_DD < 10) {_DD = '0' + _DD};

  let _r = '';
  if (p_mode=='-'){
    _r = '{}-{}-{}'.f(_YYYY, _MM, _DD)
  }
  else if (p_mode=='年月日'){
    _r = '{}年{}月{}日'.f(_YYYY, _MM, _DD)
  };
  return _r; 
};

static myDT_getDff(p_mode, p_dtm1, p_dtm2) {
  let _o_dtm1 = new Date(String(ff.myDT_cnv('24', p_dtm1)).replace(' ', 'T'));
  let _o_dtm2 = new Date(String(ff.myDT_cnv('24', p_dtm2)).replace(' ', 'T'));
  if (p_mode == 'day') { // 日単位
    return (_o_dtm2 - _o_dtm1) / 86400000 | 0;
  };
  if (p_mode == 'hour') { // 日単位
    return (_o_dtm2 - _o_dtm1) / 3600000 | 0;
  };
  if (p_mode == 'mnt') { // 分単位
    return (_o_dtm2.getTime() - _o_dtm1.getTime()) / 60000 | 0; // ミリ秒を変換、端数切り捨て
  };
  if (p_mode == 'scd') { // 秒単位
    return (_o_dtm2.getTime() - _o_dtm1.getTime()) / 1000 | 0; // ミリ秒を変換、端数切り捨て
  };
};

static myDT_getNow = () => {
  let _dtm = new Date();
  let _YYYY = _dtm.getFullYear();
  var _MM = _dtm.getMonth()+1; //１を足すこと
  if (_MM < 10) {
    _MM = '0' + _MM;
  };
  var _DD = _dtm.getDate();
  if (_DD < 10) {
    _DD = '0' + _DD;
  };
  var _hh = _dtm.getHours();
  if (_hh < 10) {
    _hh = '0' + _hh;
  };
  var _mm = _dtm.getMinutes();
  if (_mm < 10) {
    _mm = '0' + _mm;
  };
  var _ss = _dtm.getSeconds();
  if (_ss < 10) {
    _ss = '0' + _ss;
  };
  return '{}-{}-{} {}:{}:{}'.f(_YYYY, _MM, _DD, _hh, _mm, _ss)
};

  //////////////////////////////////////////////////////////////////////// file

  static myFL_csv = (pd={
    ld_iss: [],
    hdr: '',
    o_val: _d_is => '',
  }) => {
    let _ld_iss = bf.c(
      [pd.hdr],
      pd.ld_iss.map( _d_is => {
        return pd.o_val(_d_is)
      })
    );
    let _s = _ld_iss.join('\n');
    return _s;
  };

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
